import { Box, Stack, Typography } from "@mui/material";

import type {
  SKUStoreMediaType,
  SKUStoreResourceCardMediaProps,
} from "@/features/SKUStore/components/ResourceCard/SKUStoreResourceCard.types";

import { CardImageRegion } from "@/features/SKUStore/components/ResourceCard/SKUStoreResourceCard.shared";
import { MediaTypeBadgeRoot } from "@/features/SKUStore/components/ResourceCard/SkuStoreResourceCard.styles";
import { ImageSquareIcon, VideocamIcon } from "@/icons";

const MEDIA_TYPE_LABEL: Record<SKUStoreMediaType, string> = {
  image: "Image",
  video: "Video",
};

function MediaTypeBadge({ type }: { type: SKUStoreMediaType }) {
  const Icon = type === "video" ? VideocamIcon : ImageSquareIcon;
  return (
    <MediaTypeBadgeRoot role="img" aria-label={MEDIA_TYPE_LABEL[type]}>
      <Icon aria-hidden sx={{ fontSize: 16 }} />
    </MediaTypeBadgeRoot>
  );
}

/**
 * Media library tile (FOG-2448): the asset itself, not a product card.
 * Bare rounded image with a quiet type badge and a plain caption; no chrome.
 */
export function SKUStoreResourceCardMedia({
  imageSrc,
  imageAlt = "",
  title,
  subtitle,
  mediaType,
  meta,
}: SKUStoreResourceCardMediaProps) {
  return (
    <Stack spacing={2} sx={{ width: 1, minWidth: 0 }}>
      <Box sx={{ position: "relative" }}>
        <CardImageRegion
          imageAlt={imageAlt}
          imageSrc={imageSrc}
          sx={(theme) => ({ borderRadius: `${theme.shape.borderRadiusLg}px` })}
        />
        {mediaType != null && <MediaTypeBadge type={mediaType} />}
      </Box>
      <Stack spacing={1} sx={{ minWidth: 0 }}>
        <Typography component="div" noWrap variant="body2">
          {title}
        </Typography>
        {subtitle != null && (
          <Typography
            component="div"
            variant="body3"
            sx={{ color: "text.secondary" }}
          >
            {subtitle}
          </Typography>
        )}
        {meta != null && (
          <Typography
            component="div"
            variant="body3"
            sx={{ color: "text.secondary" }}
          >
            {meta}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
